import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const automatedmessages = {
    state: () => ({
        items: [],
        timeout: null,
    }),
    mutations: {
        setAutomatedMessageList(state, payload) {
            state.items = payload;
        },
    },
    actions: {
        async getAutomatedMessageLogs(store, payload) {
            var res = await axios.post('AutomatedMessages/ListLogs', {...payload, skip: (payload.page - 1) * payload.take });
            return res;
        },
        async getAutomatedMessagesList(store) {
            var res = await axios.post('AutomatedMessages/List', { skip: 0, take: 1000 });
            store.commit('setAutomatedMessageList', res.data.data.items);
        },
        async toggleAutomatedMessage(store, payload) {
            var res = await axios.post('AutomatedMessages/ToggleIsActive', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getAutomatedMessage(store, payload) {
            var res = await axios.post('AutomatedMessages/Get', { id: payload });
            return res;
        },
        async addUpdateVoucher(store, payload) {
            var res = await axios.post('AutomatedMessages/AddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async addUpdatePush(store, payload) {
            var res = await axios.post('AutomatedMessages/AddOrUpdatePush', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteAutomatedMessage(store, payload) {
            var res = await axios.post('AutomatedMessages/Delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default automatedmessages;


// WEBPACK FOOTER //
// ./src/store/automatedmessages.js